import FundListComponent from "../components/FundList";
import useFundList from "../hook/useFundList";

const FundList = () => {
    const fundListProps = useFundList();

    return <FundListComponent {...fundListProps} />;
};

export default FundList;